import { GlobalConnex } from "../GlobalConnex.jsx";
import { AUTH_SOURCES, decodeAccessToken, saveAuthTokens } from "../../shared/auth/lib/authSession";

class AuthService {
    constructor() {
        this.baseUrl = GlobalConnex.url;
    }

    /**
     * Genera la URL completa para los endpoints de entrega.
     * @param {string} endpoint - Endpoint relativo.
     * @returns {string} - URL completa.
     */
    buildUrl(endpoint) {
        return this.baseUrl + endpoint;
    }

    /**
     * Intercambia un access_token de Keycloak (obtenido vía keycloak-js en
     * el navegador) por el JWT propio de la app, y guarda los tokens en el
     * almacenamiento local igual que el resto de los flujos de sesión.
     * @param {string} keycloakAccessToken - access_token emitido por Keycloak.
     * @returns {Promise<object>} - Respuesta del servidor.
     */
    async loginWithKeycloak(keycloakAccessToken) {
        const url = this.buildUrl(`auth/keycloak/exchange/`);
        const headers = {
            "Content-Type": "application/json"
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify({ keycloak_access_token: keycloakAccessToken }),
                headers,
                mode: "cors",
            });

            const resp = await response.json();

            if (resp.access && resp.refresh) {
                const decodeToken = await this.decodeToken(resp.access);
                await this.saveToLocalStorage(resp, decodeToken, AUTH_SOURCES.keycloak);
            } else {
                console.error("Error: el intercambio de sesión institucional (Keycloak) no devolvió tokens", resp);
            }
            return resp;
        } catch (error) {
            console.error("Error en el intercambio de sesión con Keycloak:", error);
            throw error;
        }
    }

    async conex(data) {
        const url = this.buildUrl(`validar/`);
        const headers = {
            "Content-Type": "application/json"
        };

        try {
            const response = await fetch(url, {
                method: "POST",
                body: JSON.stringify(data),
                headers,
                mode: "cors",
            });

            const resp = await response.json();

            if (resp.access && resp.refresh) {
                const decodeToken = await this.decodeToken(resp.access);
                await this.saveToLocalStorage(resp, decodeToken, AUTH_SOURCES.direct);
            } else {
                console.error("Error: Los tokens no están presentes en la respuesta");
            }
            return resp;
        } catch (error) {
            console.error("Error en el conex:", error);
        }
    }

    /**
     * Decodifica el token JWT.
     * @param {string} token - Token JWT.
     * @returns {object} - Datos decodificados del token.
     */
    decodeToken(token) {
        return decodeAccessToken(token);
    }

    /**
     * Guarda los tokens y datos del usuario en el almacenamiento local.
     * @param {object} tokens - Tokens de acceso y actualización.
     * @param {object} decodeToken - Datos decodificados del token.
     * @param {string} source - Origen de la sesión (ver AUTH_SOURCES).
     */
    saveToLocalStorage(tokens, decodeToken, source = AUTH_SOURCES.direct) {
        saveAuthTokens({
            accessToken: tokens?.access,
            refreshToken: tokens?.refresh,
            source,
        });
    }
}

export const authService = new AuthService();
